import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axiosInstance";
import { completeLogin } from "../utils/completeLogin";
import logo from "../assets/Logo_Pilcore_Vertical_Blanco.svg";
import "../LoginScreen.css";

export default function AcceptInvitationScreen() {
  const navigate = useNavigate();
  const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get("token") || new URLSearchParams(window.location.search).get("token") || "");
  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [visible, setVisible] = useState(false);
  const [repeatVisible, setRepeatVisible] = useState(false);
  const [valid, setValid] = useState(false);
  const [checking, setChecking] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const mismatch = Boolean(password && repeat && password !== repeat);
  const matches = Boolean(password && repeat && password === repeat);
  useEffect(() => {
    let cancelled = false;
    const meta = document.createElement("meta");
    meta.name = "referrer"; meta.content = "no-referrer";
    document.head.appendChild(meta);
    // Keep the secret in component memory only, never localStorage or a Referer.
    window.history.replaceState(window.history.state, "", window.location.pathname);
    axios.post("/api/users/invitation/status", { token }, { skipCrossTabSync: true }).then(() => {
      if (!cancelled) setValid(true);
    }).catch(err => {
      if (!cancelled) setError(err.response?.data?.error || "No se ha podido comprobar la invitación.");
    }).finally(() => { if (!cancelled) setChecking(false); });
    return () => { cancelled = true; meta.remove(); };
  }, [token]);
  async function submit(event) {
    event.preventDefault();
    if (!valid || busy || !matches || password.length < 12) return;
    setBusy(true); setError("");
    try {
      const { data } = await axios.post("/api/users/invitation/accept", { token, password }, { skipCrossTabSync: true });
      setPassword(""); setRepeat(""); setValid(false);
      await completeLogin(data, navigate);
    } catch (err) {
      setError(err.response?.data?.error || "No se ha podido activar tu cuenta. Inténtalo de nuevo.");
    } finally { setBusy(false); }
  }
  return <div className="auth-page">
    <img src={logo} alt="Pilcore" className="auth-watermark" />
    <div className="auth-shell">
      <div className="auth-heading"><h1>Bienvenido a Pilcore</h1><p className="auth-subtitle">Crea tu contraseña para empezar</p></div>
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-group"><label className="auth-label" htmlFor="invitation-password">Nueva contraseña</label>
          <input id="invitation-password" className="auth-input" type={visible ? "text" : "password"} value={password} onChange={e => setPassword(e.target.value)} minLength={12} autoComplete="new-password" required disabled={!valid || busy} />
          <button type="button" className="auth-help" aria-pressed={visible} onClick={() => setVisible(!visible)}>{visible ? "Ocultar contraseña" : "Mostrar contraseña"}</button>
          <p className="auth-help">Mínimo 12 caracteres.</p>
        </div>
        <div className="auth-group"><label className="auth-label" htmlFor="invitation-repeat">Repite tu contraseña</label>
          <input id="invitation-repeat" className="auth-input" type={repeatVisible ? "text" : "password"} value={repeat} onChange={e => setRepeat(e.target.value)} minLength={12} autoComplete="new-password" required disabled={!valid || busy} aria-invalid={mismatch} aria-describedby="invitation-match" />
          <button type="button" className="auth-help" aria-pressed={repeatVisible} onClick={() => setRepeatVisible(!repeatVisible)}>{repeatVisible ? "Ocultar confirmación" : "Mostrar confirmación"}</button>
        </div>
        <div id="invitation-match" aria-live="polite">{mismatch ? <p className="auth-error">Las contraseñas no coinciden.</p> : matches ? <p className="auth-success">Las contraseñas coinciden.</p> : null}</div>
        {checking && <p role="status">Comprobando invitación…</p>}
        {error && <p role="alert" className="auth-error">{error}</p>}
        <button className="auth-btn-primary" type="submit" disabled={!valid || checking || busy || !matches || password.length < 12}>{busy ? "Guardando…" : "GUARDAR CONTRASEÑA Y ENTRAR"}</button>
      </form>
    </div>
  </div>;
}
